import { useAppSelector } from '../../../hooks/store/useAppSelector';
import transactionService from '../../../../modules/transactions/transactionsService';

export const useFriendsOnlineList = () =>
	useAppSelector<Array<{ uuid: string }>>(
		(state) => state.friends.online,
		(previous, next) =>
			transactionService.isListDifferent(previous, next, ['uuid']),
	);
